export default "__VITE_ASSET__DwAnycyC__ 208w";